import $ from 'jquery';
import { getStatePure, modifyState } from '~src/state';
import { triggerStateChangedRequest } from '~core';
import { setCanvasBackground } from '~src/image';
import { removeBackground } from '~src/sidebarLegacy';

const calculateAspectRatio = (w, h) => {
  if (w === h) {
    return 'square';
  } else if (w > h) {
    return 'horizontal';
  } else if (w < h) {
    return 'vertical';
  }
};

export const displaySidebarVideoBackgrounds = () => {
  const videoMediaFiles = getStatePure('videoMediaFiles');

  const videoFiles = videoMediaFiles.videos ?? [];

  const currentBackgroundVideoId = getStatePure('backgroundVideoId');

  const canvasAspectRatio = calculateAspectRatio(
    window.canvas.width,
    window.canvas.height
  );

  // TODO: sameAspect not working
  const sameAspectRatioVideoFiles = videoFiles.filter((videoFile) => {
    const videoAspectRatio = calculateAspectRatio(
      videoFile.width,
      videoFile.height
    );

    return canvasAspectRatio === videoAspectRatio;
  });

  let html = '<div class="items-container-grid editor-sidebar-pages-editable">';
  for (const videoFile of sameAspectRatioVideoFiles) {
    const url = `${process.env.GIOTTO_VIDEO_CDN}/media/videos/${videoFile.gif}`;

    html += `<div class="sidebar-item-video sidebar-item-grid-box image-square-container ${
      currentBackgroundVideoId === videoFile.id ? 'active' : ''
    }" data-animation-select-video-id="${
      videoFile.id
    }" data-animation-select-video-gif-url="${url}">
      <div class="sidebar-item-grid-box-click-listener">
      </div>
      <img
        src="/assets/svg/img-loader.gif"
        class="lazy image-square"
        data-src="${url}"
      />
      </div>`;
  }

  html += '</div>';

  $('#editor-sidebar-video-files').html(html);
  window.lazyLoadInstance.update();

  $('body').off('click', '[data-animation-select-video-gif-url]');
  $('body').on(
    'click',
    '[data-animation-select-video-gif-url]',
    async (event) => {
      event.preventDefault();

      $('[data-animation-select-video-gif-url]').removeClass('active');

      const videoGifUrl = $(event.currentTarget).data(
        'animation-select-video-gif-url'
      );
      const videoId = $(event.currentTarget).data('animation-select-video-id');

      $(event.currentTarget).addClass('active');

      // modifyState('backgroundVideoGifUrl', videoGifUrl);
      modifyState('backgroundVideoId', videoId);
      removeBackground();
      await setCanvasBackground(videoGifUrl);
      triggerStateChangedRequest();
    }
  );
};
